/**
 * gesture.ts
 * Gestureカードの定義
 * 動き（モーション）を選択してロボットに送るノード
 */
import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { GestureNodeView } from '../views/GestureNode';
import { GestureSettings } from '../settings/GestureSettings';
import { DEFAULT_GESTURE_MOTION_ID, getGestureLabel } from '../../config/gestureMotions';
import { runMotionCard } from './motionCardRun';

const VIRTUAL_MOTION_TIMEOUT_MS = 30000;

/**
 * Gestureカードの定義
 * - パレットに表示してユーザーがドラッグ配置できる
 * - 実行時は選択されたモーションをロボットに送信
 * - 選択肢は gestureMotions.json で管理
 */
export const gestureDefinition: NodeDefinition<'gesture'> = {
  label: 'Gesture',
  showInPalette: true, // パレットに表示
  paletteColor: 'bg-violet-100 border-violet-500 text-violet-700',
  miniMapColor: '#8b5cf6', // バイオレット
  defaultData: { label: 'Gesture', motionId: DEFAULT_GESTURE_MOTION_ID }, // デフォルトは設定ファイル先頭
  view: GestureNodeView,
  settings: GestureSettings,
  run: (node, ctx, log) => runMotionCard(
    {
      logTag: 'Gesture',
      nodeKind: 'gesture',
      nodeId: node.id,
      motionId: node.data.motionId,
      motionLabel: getGestureLabel(node.data.motionId) ?? '（未設定）',
      virtualTimeoutMs: VIRTUAL_MOTION_TIMEOUT_MS,
    },
    ctx,
    log,
  ),
  help: {
    title: [t('Gesture（'), r('動', 'うご'), t('く）')],
    description: [
      r('選', 'えら'),
      t('んだ'),
      r('動', 'うご'),
      t('きを、ロボットが'),
      t('します。'),
      r('動', 'うご'),
      t('きが'),
      r('終', 'お'),
      t('わってから、つぎのカードへ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
